import React from 'react'

import Button from 'components/atoms/Button'
import Container from 'components/atoms/Container'
import Typography from 'components/atoms/Typography'

import config from 'config'
import { func } from 'prop-types'

const { assets_url: assetsUrl } = config
const peluangAssetsPath = `${assetsUrl}/assets/img/peluang`

const PeluangBanner = ({ onClickCTA }) => (
  <div className="peluang-banner">
    <Container>
      <div className="peluang-banner__wrapper">
        <Typography component="h1" variant="big" className="peluang-banner__title">
          CEK PELUANG
        </Typography>
        <Typography component="h1" variant="big">
          SBMPTN
        </Typography>
        <Typography component="p" variant="subheading" className="m-t-lg">
          Mau tahu peluang kamu lolos SBMPTN 2021?
          <br/>
          Uji kemampuanmu melalui tryout dan dapatkan hasil rasionalisasi nilai UTBK, semua secara GRATIS!
        </Typography>
        <Button
          variant="default"
          onClick={onClickCTA}
          className="peluang-banner__btn"
        >
          Cek Peluangmu
        </Button>
      </div>
    </Container>
    <style global jsx>
      {`
        .peluang-banner {
          &__wrapper {
            max-width: 400px;
          }
          :global(&__title) {
            font-weight: normal;
          }
          :global(&__btn) {
            font-weight: bold;
            padding: 16px 42px;
            border-radius: 8px;
            margin-top: 24px;
          }
          @media screen and (min-width: 768px) {
            background-image: url(${peluangAssetsPath}/header-pc.png);
            background-color: #d6f5ff;
            background-size: auto 480px;
            background-position: bottom right;
            background-repeat: no-repeat;
            padding: 120px 0;
            :global(&__bg-pc) {
              position: absolute;
              top: 0;
              right: 0;
              z-index: -1;
              height: 480px;
            }
          }
          @media screen and (max-width: 767px) {
            background-image: url(${peluangAssetsPath}/header-sp.jpg);
            background-color: #d6f5ff;
            background-position: bottom;
            background-repeat: no-repeat;
            background-size: contain;
            padding: 48px 0 240px 0;
            :global(&__bg-sp) {
              width: 100%;
            }
            :global(&__btn) {
              display: block;
            }
          }
        }
      `}
    </style>
  </div>
)

PeluangBanner.propTypes = {
  onClickCTA: func,
}

export default PeluangBanner
